// Libs
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// Actions
import { sendToast } from 'screens/Dashboard/actions';
// Components
import { DeleteIcon, LogoIcon } from 'components';

const DeleteValue = ({ rowData, field, selected }) => {
	const [state, _setState] = useState({
		isFetching: false,
	});

	const setIsfetching = () =>
		_setState(current => ({
			...current,
			isFetching: !current.isFetching,
		}));

	const dispatch = useDispatch();
	const sendMessage = ({ message, type = 'success' }) =>
		dispatch(
			sendToast({
				message,
				type,
				duration: 2,
			}),
		);

	const selectedRowId = rowData?.wtdi_id || rowData?.wtdiId || rowData?.Id;

	const onClick = e => {
		e.stopPropagation();
		setIsfetching();

		const selectionKey = selected.itemKey || 'id';
		const rowIdentity = rowData?.[selectionKey];
		field.onChange &&
			field.onChange(
				rowIdentity === undefined
					? [...selected.items]
					: [...selected.items, rowIdentity],
			);
		Promise.resolve(
			field.onClick &&
				field.onClick({
					selectedItems: selected.items,
					selectedItem: selectedRowId,
					rowData,
				}),
		)
			.then(({ message = '', onThen = () => {} } = {}) => {
				if (message) sendMessage({ message });
				setIsfetching();
				onThen();
			})
			.catch(({ message = '', onCatch = () => {} } = {}) => {
				if (message) sendMessage({ message, type: 'error' });
				setIsfetching();
				onCatch();
			});
	};

	return state.isFetching ? (
		<LogoIcon spin />
	) : (
		<DeleteIcon button onClick={onClick} />
	);
};

export default DeleteValue;
